module.exports = __webpack_public_path__ + "media/brand/scribble-yellow-0540be3f.svg";